export enum SLPStatus {
  Pending = 1,
  InProgress = 2,
  Completed = 3,
}

export enum ContactProgress {
  NotStarted = 1,
  InProgress = 2,
  Assigned = 3,
}

export enum SLPParticipation {
  Active = 1,
  NoFurtherSLPRequired = 2,
}

export enum ContactDateNumber {
  ContactDateOne = 1,
  ContactDateTwo = 2,
}
